import { QuestionShowCondition } from '@nx-customer-apps/shared/interfaces';

/**
 * Evaluates a question's subQuestionShowWhen condition against a related control value.
 * Returns true when no condition is provided (question is always visible).
 */
export function isQuestionConditionMet(value: unknown, condition?: QuestionShowCondition): boolean {
    if (!condition) {
        return true;
    }
    const expected = Array.isArray(condition.equals) ? condition.equals : [condition.equals];
    return expected.includes(value);
}
